<mat-form-field [style.width]="width" floatLabel="always">
  <mat-label>{{ label }}</mat-label>
  @if (!readonly) {
    <mat-select class="unit-select" [formControl]="formControl" [required]="required" (selectionChange)="selectionChange.emit($event)">
      <mat-option>&mdash; Select Unit &mdash;</mat-option>
      @for (unit of units; track unit) {
        <mat-option [value]="$safeNavigationMigration(unit?.id)" [matTooltip]="unit?.longName" matTooltipPosition="right"
          >{{ unit?.shortName }}
        </mat-option>
      }
    </mat-select>
  }
  @if (readonly) {
    <input matInput [value]="$safeNavigationMigration(selectedUnit?.shortName)" [disabled]="formControl.disabled" readonly [required]="required" [matTooltip]="selectedUnit?.longName"/>
  }
  @if (leftPadding) {
    <span matPrefix>&nbsp;</span>
  }
  @if (formControl.hasError('required')) {
    <mat-error>A unit selection is required</mat-error>
  }
</mat-form-field>
